<template>
  <div class="content-wrapper">
    <Loading
      v-if="recipientType === 'single' ? !loadStatus : loadStatus"
      text="Loading ..."
      style="margin-left: 0px;"
    />

    <div v-if="recipientType === 'single' ? loadStatus : !loadStatus">
      <SendGiftMenu
        :header="isConfirmedOrder ? 'Order Confirmation' : ' Review Order'"
        :display-shopping-bag="false"
        :display-stepper="true"
        :display-back="isConfirmedOrder ? false : true"
        :back-to="
          isSalesForceConnected ? 'LinkSalesForceRecord' : 'CardMessage'
        "
      />

      <div>
        <!-- Order Header -->
        <OrderDetailHeader
          :order="isConfirmedOrder ? data.order : individualOrder"
          :recipient="isConfirmedOrder ? data.recipient : recipient"
          :cardMessage="isConfirmedOrder ? data.cardMessage : cardMessage"
          :showEditButtons="isConfirmedOrder ? false : true"
          :recipientType="isConfirmedOrder ? data.recipientType : recipientType"
          :isConfirmedOrder="isConfirmedOrder"
        />

        <!-- Sales Force Resource -->
        <div v-if="salesforceResourceType">
          <h5 class="text-left">
            Overview
          </h5>

          <h5 class="text-left">
            Salesforce Resource
            {{ salesforceResourceType }}
            -
            {{ salesforceResourceUid }}
          </h5>
        </div>

        <!-- Order Items -->
        <ConfirmOrderItemsList
          :taxamount="parseFloat(taxAmount)"
          :cardMessage="isConfirmedOrder ? data.cardMessage : cardMessage"
          :shoppingBagProducts="
            isConfirmedOrder ? data.cart : shoppingBagProducts
          "
          :recipientType="isConfirmedOrder ? data.recipientType : recipientType"
        />

        <div
          class="flex items-center justify-center confirm-button"
          v-if="shoppingBagProducts.length && !isConfirmedOrder"
        >
          <button
            class="button-gemnote full-width button-gemnote--small"
            :class="{ 'button-gemnote--disabled': disabledPayButton }"
            :disabled="disabledPayButton"
            @click="payOrder"
          >
            <span>Place order</span>
          </button>
        </div>

        <!-- Reroute region -->
        <div class="swag-store inter" v-if="isConfirmedOrder">
          <button @click="handleRouting">
            Back to Swag Store
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus, layouts, storeModules } from '../../helpers'
import Loading from '@/components/Loading'
import OrderDetailHeader from '@/components/Orders/OrderDetailHeader'
import ConfirmOrderItemsList from '@/components/SendGiftFlow/ConfirmOrderItemsList'
import SendGiftMenu from '@/components/SendGiftMenu'
import store from '../../store'

export default {
  name: 'ConfirmOrder',

  components: {
    Loading,
    OrderDetailHeader,
    ConfirmOrderItemsList,
    SendGiftMenu
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },

  data: () => ({
    data: {}
  }),

  computed: {
    ...mapState({
      loadRecipient: state => state.recipient.loadRecipient,
      recipient: state => state.recipient.recipient,
      individualOrder: state => state.order.individualOrder,
      selectedRecipientId: state => state.order.selectedRecipientId,
      currentOrderId: state => state.order.currentOrderId,

      disabledPayButton: state => state.order.disabledPayButton,
      shoppingBagProducts: state => state.order.shoppingBagProducts,
      cardMessage: state => state.order.cardMessage,
      recipientType: state => state.recipient.recipientType,
      selectedOption: state => state.recipient.orderRecipientList
    }),
    taxAmount() {
      return this.isConfirmedOrder
        ? this.data && this.data.order && this.data.order.taxAmount
        : this.individualOrder.taxAmount
    },
    salesforceResourceType() {
      return this.isConfirmedOrder
        ? this.data && this.data.order && this.data.order.salesforceResourceType
        : this.individualOrder.salesforceResourceType
    },
    salesforceResourceUid() {
      return this.isConfirmedOrder
        ? this.data && this.data.order && this.data.order.salesforceResourceUid
        : this.individualOrder.salesforceResourceUid
    },
    loadStatus() {
      return progressStatus(this.loadRecipient)
    },
    isSalesForceConnected() {
      return this.$store.getters['integration/isSalesForceConnected']
    },
    isOrderSuccess() {
      return this.$route.params.isOrderSuccess
    },
    isConfirmedOrder() {
      return this.$route.name === 'ConfirmedOrder'
    }
  },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.getRecipient()
    this.loadLocalCart()
  },

  methods: {
    payOrder() {
      this.handleLocalCart()
      localStorage.removeItem('selectedCard')
      if (this.recipientType === 'single') {
        this.$store.dispatch('order/payOrder', this.currentOrderId)
      } else {
        return this.$store.dispatch(
          'order/createMultipleOrder',
          this.selectedOption.id
        )
      }
    },
    getRecipient() {
      if (this.recipientType === 'single') {
        if (this.selectedRecipientId) {
          this.$store.dispatch(
            'recipient/getRecipient',
            this.selectedRecipientId
          )
          this.$store.dispatch('order/getIndividualOrder', this.currentOrderId)
        } else {
          this.$router.push({ name: 'GiftList' })
        }
      }
    },
    loadLocalCart() {
      const data = localStorage.getItem('localCart')
      if (data && this.isConfirmedOrder) {
        this.data = JSON.parse(data)
      }
    },

    handleLocalCart() {
      const neededData = {
        cart: this.shoppingBagProducts,
        recipient: this.recipient,
        cardMessage: this.cardMessage,
        order: this.individualOrder,
        recipientType: this.recipientType
      }

      localStorage.setItem('localCart', JSON.stringify(neededData))
    },

    handleRouting() {
      localStorage.removeItem('localCart')
      this.$router.push('/gifts')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.content-wrapper {
  /* padding-right: 15%; */
}

@media (max-width: 1450px) {
  .content-wrapper {
    padding-right: 0%;
  }
}

.swag-store {
  margin-top: 4rem;
  display: flex;
  justify-content: center;

  button {
    text-transform: uppercase;
    height: 3rem;
    padding: 0 2rem;
    border-radius: 40px;
    color: $onyx;

    border: 1px solid #000;
    font-weight: normal;
    font-size: 0.813rem;
  }
}
.confirm-button {
  border-top: 1px solid #dfdad2;
  margin-top: 2rem;
}

.button-gemnote--small {
  height: 3rem !important;
  padding: 0 2rem !important;
  margin-top: 2.5rem;
  font-size: 0.813rem;
}
</style>
